function leadFormModelService (localStorageService) {
    let previousFormData, userSummary, userData, alertEmail;

    const CARS_EMAIL_FORM_DATA = 'Cars.emailFormData';
    const CARS_USER_SUMMARY = 'cars.userSummary';
    const CARS_USER_DATA = 'Cars.userData';
    const CARS_ALERT_EMAIL = 'cars.alertEmail';

    return {
        getModel
    };

    function getModel (seller) {
        getCachedData();

        let model = {
            firstName: getFirstName(),
            lastName: getLastName(),
            email: getEmail(),
            phone: getPhone(),
            zipCode: getZipCode(),
            hasRequiredFields: getHasRequiredFields(),
            isLoggedIn: getIsLoggedIn()
        };

        if (seller.hasSellAndTrade) {
            model = getTradeInInfo(model);
        } else if (seller.hasSecureCreditApp) {
            model.scaInterest = getScaInterest();
        }

        return model;
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////

    function getCachedData () {
        previousFormData = JSON.parse(localStorageService.getItem(CARS_EMAIL_FORM_DATA)) || {};
        userSummary = JSON.parse(localStorageService.getItem(CARS_USER_SUMMARY)) || {};
        userData = JSON.parse(localStorageService.getItem(CARS_USER_DATA)) || {};
        alertEmail = localStorageService.getItem(CARS_ALERT_EMAIL);
    }

    function getFirstName () {
        return previousFormData.firstName || userSummary.firstName;
    }

    function getLastName () {
        return previousFormData.lastName || userSummary.lastName;
    }

    function getEmail () {
        return previousFormData.email || userSummary.email || alertEmail;
    }

    function getPhone () {
        return previousFormData.phone;
    }

    function getZipCode () {
        return previousFormData.zipCode || userData.zip;
    }

    function getIsLoggedIn () {
        if (userData.carsVisitor) {
            let carsVisitor = JSON.parse(userData.carsVisitor);
            if (carsVisitor.pcid && carsVisitor.pcid !== "null") {
                return true;
            }
        }
        return false;
    }

    function getHasRequiredFields () {
        if (previousFormData.firstName && previousFormData.lastName && previousFormData.email) {
            return true;
        } else if (userSummary.firstName && userSummary.lastName && userSummary.email) {
            return true;
        } else {
            return false;
        }
    }

    function getScaInterest () {
        return previousFormData.scaInterest || false;
    }

    function getTradeInInfo (model) {
        const tradeIn = {
            offerTradeIn: 'Y',
            tradeInYear: previousFormData.tradeInYear,
            tradeInMake: previousFormData.tradeInMake,
            tradeInModel: previousFormData.tradeInModel,
            tradeInExteriorColor: previousFormData.tradeInExteriorColor,
            tradeInMileage: previousFormData.tradeInMileage,
            tradeInVin: previousFormData.tradeInVin
        };

        return { ...model, ...tradeIn };
    }
}

leadFormModelService.$inject = [
    'localStorageService'
];

export default leadFormModelService;
